const single = (countryCode, country, timezone, currency) => ({
    code: countryCode,
    countryCode,
    country,
    label: country,
    timezone,
    currency,
});
const zone = (countryCode, country, suffix, city, timezone, currency) => ({
    code: `${countryCode}-${suffix}`,
    countryCode,
    country,
    label: `${country} — ${city}`,
    timezone,
    currency,
});
export const REGIONS = [
    // South Asia
    single('PK', 'Pakistan', 'Asia/Karachi', 'PKR'),
    single('IN', 'India', 'Asia/Kolkata', 'INR'),
    single('BD', 'Bangladesh', 'Asia/Dhaka', 'BDT'),
    single('LK', 'Sri Lanka', 'Asia/Colombo', 'LKR'),
    single('NP', 'Nepal', 'Asia/Kathmandu', 'NPR'),
    single('AF', 'Afghanistan', 'Asia/Kabul', 'AFN'),
    // Gulf and Middle East
    single('AE', 'United Arab Emirates', 'Asia/Dubai', 'AED'),
    single('SA', 'Saudi Arabia', 'Asia/Riyadh', 'SAR'),
    single('QA', 'Qatar', 'Asia/Qatar', 'QAR'),
    single('KW', 'Kuwait', 'Asia/Kuwait', 'KWD'),
    single('OM', 'Oman', 'Asia/Muscat', 'OMR'),
    single('BH', 'Bahrain', 'Asia/Bahrain', 'BHD'),
    single('JO', 'Jordan', 'Asia/Amman', 'JOD'),
    single('IQ', 'Iraq', 'Asia/Baghdad', 'IQD'),
    single('TR', 'Türkiye', 'Europe/Istanbul', 'TRY'),
    single('EG', 'Egypt', 'Africa/Cairo', 'EGP'),
    // South-east Asia
    single('MY', 'Malaysia', 'Asia/Kuala_Lumpur', 'MYR'),
    single('SG', 'Singapore', 'Asia/Singapore', 'SGD'),
    single('PH', 'Philippines', 'Asia/Manila', 'PHP'),
    zone('ID', 'Indonesia', 'WIB', 'Jakarta (western)', 'Asia/Jakarta', 'IDR'),
    zone('ID', 'Indonesia', 'WITA', 'Makassar (central)', 'Asia/Makassar', 'IDR'),
    zone('ID', 'Indonesia', 'WIT', 'Jayapura (eastern)', 'Asia/Jayapura', 'IDR'),
    // Europe
    single('GB', 'United Kingdom', 'Europe/London', 'GBP'),
    single('IE', 'Ireland', 'Europe/Dublin', 'EUR'),
    single('DE', 'Germany', 'Europe/Berlin', 'EUR'),
    single('FR', 'France', 'Europe/Paris', 'EUR'),
    single('NL', 'Netherlands', 'Europe/Amsterdam', 'EUR'),
    single('ES', 'Spain', 'Europe/Madrid', 'EUR'),
    single('IT', 'Italy', 'Europe/Rome', 'EUR'),
    // Africa
    single('ZA', 'South Africa', 'Africa/Johannesburg', 'ZAR'),
    single('NG', 'Nigeria', 'Africa/Lagos', 'NGN'),
    single('KE', 'Kenya', 'Africa/Nairobi', 'KES'),
    // Australia
    zone('AU', 'Australia', 'NSW', 'Sydney / Melbourne / Canberra', 'Australia/Sydney', 'AUD'),
    zone('AU', 'Australia', 'QLD', 'Brisbane', 'Australia/Brisbane', 'AUD'),
    zone('AU', 'Australia', 'SA', 'Adelaide', 'Australia/Adelaide', 'AUD'),
    zone('AU', 'Australia', 'WA', 'Perth', 'Australia/Perth', 'AUD'),
    // North America
    zone('CA', 'Canada', 'ET', 'Toronto / Ottawa / Montréal', 'America/Toronto', 'CAD'),
    zone('CA', 'Canada', 'CT', 'Winnipeg', 'America/Winnipeg', 'CAD'),
    zone('CA', 'Canada', 'MT', 'Edmonton / Calgary', 'America/Edmonton', 'CAD'),
    zone('CA', 'Canada', 'PT', 'Vancouver', 'America/Vancouver', 'CAD'),
    zone('CA', 'Canada', 'AT', 'Halifax', 'America/Halifax', 'CAD'),
    zone('US', 'United States', 'ET', 'New York (Eastern)', 'America/New_York', 'USD'),
    zone('US', 'United States', 'CT', 'Chicago (Central)', 'America/Chicago', 'USD'),
    zone('US', 'United States', 'MT', 'Denver (Mountain)', 'America/Denver', 'USD'),
    zone('US', 'United States', 'AZ', 'Phoenix (Arizona, no DST)', 'America/Phoenix', 'USD'),
    zone('US', 'United States', 'PT', 'Los Angeles (Pacific)', 'America/Los_Angeles', 'USD'),
    zone('US', 'United States', 'AK', 'Anchorage (Alaska)', 'America/Anchorage', 'USD'),
    zone('US', 'United States', 'HI', 'Honolulu (Hawaii)', 'Pacific/Honolulu', 'USD'),
    single('CO', 'Colombia', 'America/Bogota', 'COP'),
    // Kept for platform-level records and tests that have no country.
    { code: 'UTC', countryCode: null, country: 'UTC', label: 'UTC (no country)', timezone: 'UTC', currency: 'USD' },
];
export const REGION_CODES = REGIONS.map((region) => region.code);
/** Every zone a hospital may be in — the only values `tenant.timezone` accepts. */
export const TIMEZONES = [...new Set(REGIONS.map((region) => region.timezone))];
export function regionByCode(code) {
    return REGIONS.find((region) => region.code === code);
}
/**
 * The region a stored timezone belongs to, for showing an existing hospital's
 * setting back in the picker. Several regions can share a zone (Sydney and
 * Melbourne); the first listed wins, which is fine — they are the same clock.
 */
export function regionForTimezone(timezone) {
    return REGIONS.find((region) => region.timezone === timezone);
}
//# sourceMappingURL=regions.js.map